<div class="flex-table-page">
<div class="px-6 pt-6 flex-table-header">
  <h2 class="text-2xl font-semibold text-gray-800">
    {{ "carrier.management.title" | translate }}
  </h2>
</div>
<div class="px-6 py-4 flex flex-col flex-1 min-h-0">
  <!-- Search Form -->
  <app-search-form
    data-testid="carrier-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        data-testid="carrier-status-filter"
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onAdd()"
        (secondaryButtonClick)="onColumnConfigClick($event)"
      ></app-status-filter>
    </div>
  </app-search-form>
  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      data-testid="carrier-table"
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Status Column -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "status") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            [attr.data-testid]="'carrier-status-tag-' + rowData.id"
            [value]="getStatusDisplayText(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
          />
        </div>
      }

      @if (column?.prop === "health") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            [attr.data-testid]="'carrier-health-tag-' + rowData.id"
            [value]="getHealthStatusDisplayText(value)"
            [severity]="getHealthSeverity(value)"
            styleClass="status-tag"
          />
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex items-center justify-center gap-2">
        @if (canRead()) {
          <app-button
            [testId]="'carrier-action-view-' + rowData.id"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
        @if (canUpdate()) {
          <app-button
            [testId]="'carrier-action-edit-' + rowData.id"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [testId]="'carrier-action-toggle-status-' + rowData.id"
            [class]="
              rowData.status === 'ACTIVE' ? 'action-disable' : 'action-enable'
            "
            [label]="
              rowData.status === 'ACTIVE'
                ? ('common.table.actions.deactivate' | translate)
                : ('common.table.actions.activate' | translate)
            "
            type="action"
            (emitOnClick)="
              onStatusChange(
                rowData,
                rowData.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
              )
            "
          ></app-button>
        }
        @if (canDelete()) {
          <app-button
            [testId]="'carrier-action-delete-' + rowData.id"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="carrier-toast"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'carrier-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
